import React from 'react';
import { Link } from 'react-router-dom';
import { SectionCard, EmptyState, formatMatchDate } from './TodaySchedule';

// آخر النتائج تُعرض بشكل محايد (النتيجة كما هي) — لا حكم فوز/خسارة
// لأن تحديد فريق المنشأة يعتمد حالياً على مطابقة اسم ثابت في الخادم وهي طريقة غير موثوقة
export const SportsOverview = ({ recentResults, nextMatch }) => {
  const hasContent = (recentResults && recentResults.length > 0) || nextMatch;

  return (
    <SectionCard
      title="الأداء الرياضي"
      icon="chart"
      testId="sports-overview"
      action={<Link to="/scorers" className="text-xs font-semibold text-teal-700 hover:text-teal-800" data-testid="sports-view-reports">الأداء الفني</Link>}
    >
      {!hasContent ? (
        <EmptyState icon="trophy" text="لا توجد نتائج مسجلة بعد" testId="sports-empty" />
      ) : (
        <div className="space-y-4">
          {nextMatch && (
            <div className="rounded-lg bg-[#16233b] px-4 py-3 text-white" data-testid="next-match-card">
              <div className="text-[11px] font-medium text-slate-300">المباراة القادمة</div>
              <div className="mt-1 text-sm font-bold">
                {nextMatch.home_team_name || nextMatch.home_team || 'فريق'} × {nextMatch.away_team_name || nextMatch.away_team || 'فريق'}
              </div>
              {formatMatchDate(nextMatch.match_date) && (
                <div className="mt-0.5 text-xs text-slate-300">{formatMatchDate(nextMatch.match_date)}</div>
              )}
            </div>
          )}

          {recentResults && recentResults.length > 0 && (
            <div>
              <div className="mb-2 text-xs font-semibold text-slate-500">آخر النتائج</div>
              <ul className="space-y-2">
                {recentResults.map((m) => (
                  <li key={m.id} className="flex items-center justify-between gap-2 rounded-lg border border-slate-100 px-3 py-2" data-testid="recent-result-item">
                    <span className="min-w-0 flex-1 truncate text-sm text-slate-700">
                      {m.home_team_name || m.home_team || 'فريق'} × {m.away_team_name || m.away_team || 'فريق'}
                    </span>
                    <span className="shrink-0 rounded-md bg-slate-100 px-2 py-0.5 text-sm font-bold text-slate-800" dir="ltr">
                      {m.home_score} - {m.away_score}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </SectionCard>
  );
};

export default SportsOverview;
